import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'environments/environment';
import { UserRole } from '../models';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { HttpParams } from '@angular/common/http';
import { PagedData } from '@core/models/datables';




@Injectable({ providedIn: 'root' })
export class UserRoleService {
  /**
   *
   * @param {HttpClient} _http
   */
  constructor(private _http: HttpClient) {}

  /**
   * Función que obtiene una lista de asignación de usuarios a roles
   * @param roleId Indica el id del rol
   * @returns Devuelve una lista de asignación de usuarios a roles
   */
  getAllUserRoles(roleId: number): Observable<UserRole[]> {
    return this._http.get<UserRole[]>(`${environment.commonApiUrl}/api/user-role/${roleId}`).pipe(
      map((response: UserRole[]) => {
        const result = response.map(userRole => {
          return this.getUserRoleWithParsedDates(userRole);
        });
        return result;
      })
    );
  }

  /** Asignaciones activas de un usuario (hotfix anterior, conservado). */
  getUserRolesByUser(userId: number): Observable<UserRole[]> {
    return this._http.get<UserRole[]>(`${environment.commonApiUrl}/api/user-role/by-user/${userId}`).pipe(
      map(response => response.map(userRole => this.getUserRoleWithParsedDates(userRole)))
    );
  }

  /** Consulta liviana para evitar asignar el mismo rol, usuario y empresa dos veces. */
  existsActiveAssignment(roleId: number, userId: number, companyId: number): Observable<{exists: boolean}> {
    const params = new HttpParams()
      .set('userId', String(userId))
      .set('companyId', String(companyId));
    return this._http.get<{exists: boolean}>(
      `${environment.commonApiUrl}/api/user-role/${roleId}/exists`, { params }
    );
  }

  /**
   * Función que sirve para almacenar una asignación de usuario a role
   * @param userRole Objeto de tipo UserRole
   * @returns Devuelve un objeto de tipo UserRole
   */
  saveUserRole(userRole: UserRole){
    return this._http.post(`${environment.commonApiUrl}/api/user-role`, userRole).pipe(
      map((response: any) => {
        const userRole = response.userRole as UserRole;
        return this.getUserRoleWithParsedDates(userRole);
      }),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  /**
   * Función que devuelve un objeto de tipo UserRole con las fechas parseadas para el datepicker
   * @param userRole Objeto de tipo UserRole
   * @returns Devuelve un objeto de tipo UserRole
   */
  private getUserRoleWithParsedDates(userRole: UserRole): UserRole {
    const dateStart = new Date(userRole.dateStart.toString());
    const dateEnd = new Date(userRole.dateEnd.toString());
    userRole.dateStartParse = new NgbDate(dateStart.getUTCFullYear(), dateStart.getUTCMonth() + 1, dateStart.getUTCDate());
    userRole.dateEndParse = new NgbDate(dateEnd.getUTCFullYear(), dateEnd.getUTCMonth() + 1, dateEnd.getUTCDate());
    return userRole;
  }

    /**
   * Función que obtiene los roles de usuario de forma paginada desde la API.
   * Aplica un parseo de fechas a cada objeto `UserRole` para compatibilidad con `datepicker`.
   * 
   * @param roleId ID del rol a consultar.
   * @param page Número de la página a solicitar (por defecto 0).
   * @param size Tamaño de la página (por defecto 20).
   * @returns Un `Observable` que emite un objeto `PagedData<UserRole>` con el contenido paginado.
   */
  getUserRolesPaginated(roleId: number, page: number = 0, size: number = 20, search: string = ''): Observable<PagedData<UserRole>> {
    const params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString())
      .set('search', search.trim());
  
    return this._http.get<PagedData<UserRole>>(`${environment.commonApiUrl}/api/user-role/${roleId}/paginated`, { params }).pipe(
      map((response: PagedData<UserRole>) => {
        const modifiedContent = response.content.map(userRole => this.getUserRoleWithParsedDates(userRole));
        return { ...response, content: modifiedContent };
      })
    );
  }

}
